module.exports = __webpack_public_path__ + "img/icon-11.ee439ce0.png";